import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import { getEmpresaAtual } from './api';
import {
  coresHex, hexParaRgb, escurecer, clarear,
} from '../styles/styleUtils';

// Converte um hex de coresHex em rgb() 0-1 do pdf-lib (que não entende var()/hex).
const rgbHex = (hex) => {
  const { r, g, b } = hexParaRgb(hex);
  return rgb(r / 255, g / 255, b / 255);
};

// ── Gráfico de Pizza via Canvas ───────────────────────────────────────────
const gerarGraficoPizzaCanvas = (dadosMotivos, total, cores) => new Promise((resolve) => {
  const size   = 300;
  const canvas = document.createElement('canvas');
  canvas.width  = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  const cx  = size / 2;
  const cy  = size / 2;
  const r   = size * 0.38;

  let startAngle = -Math.PI / 2;
  dadosMotivos.forEach((d, i) => {
    const slice = total > 0 ? (d.qtd / total) * 2 * Math.PI : 0;
    ctx.beginPath();
    ctx.moveTo(cx, cy);
    ctx.arc(cx, cy, r, startAngle, startAngle + slice);
    ctx.closePath();
    ctx.fillStyle = cores[i % cores.length];
    ctx.fill();
    ctx.strokeStyle = '#fff';
    ctx.lineWidth = 1.5;
    ctx.stroke();

    if (slice > 0.25) {
      const mid = startAngle + slice / 2;
      const lx  = cx + Math.cos(mid) * r * 0.65;
      const ly  = cy + Math.sin(mid) * r * 0.65;
      const pct = ((d.qtd / total) * 100).toFixed(1);
      ctx.fillStyle    = '#fff';
      ctx.font         = 'bold 11px Arial';
      ctx.textAlign    = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(`${pct}%`, lx, ly);
    }
    startAngle += slice;
  });

  resolve(canvas.toDataURL('image/png'));
});

const generatePdfRejeitadosServico = async (data, filtro, isSupervisor) => {
  if (!data) return;

  const pdfDoc  = await PDFDocument.create();
  const fontReg = await pdfDoc.embedFont(StandardFonts.Helvetica);
  const fontBold= await pdfDoc.embedFont(StandardFonts.HelveticaBold);

  const W = 595.28; const H = 841.89;
  const ML = 40; const MR = 40;
  const CW = W - ML - MR;

  const C = {
    cinzaChumbo: rgbHex(coresHex.chumbo),
    cinzaMedio:  rgbHex(coresHex.cinzaMedio),
    cinzaClaro:  rgbHex(coresHex.cinzaClaro),
    laranja:     rgbHex(coresHex.laranja),
    laranjaClaro:rgbHex(coresHex.laranjaClaro),
    laranjaEsc:  rgbHex(coresHex.laranjaEscuro),
    branco:      rgb(1, 1, 1),
    preto:       rgb(0.133, 0.133, 0.133),
    borda:       rgbHex(coresHex.borda),
  };

  
    const CORES_HEX = [
    coresHex.laranja,
    coresHex.chumbo,
    escurecer(coresHex.laranja, 0.30),
    coresHex.cinzaMedio,
    escurecer(coresHex.laranja, 0.60),
    clarear(coresHex.chumbo, 0.45),
    escurecer(coresHex.laranja, 0.80),
    clarear(coresHex.cinzaMedio, 0.20),
    clarear(coresHex.laranja, 0.55),
  ];
  const CORES_RGB = CORES_HEX.map(rgbHex);

  const brl    = (v) => parseFloat(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const fmtNum = (v) => Number(v || 0).toLocaleString('pt-BR');

  const drawRect  = (pg, x, y, w, h, color) => pg.drawRectangle({ x, y, width: w, height: h, color });
  const drawBRect = (pg, x, y, w, h, fill, border) => pg.drawRectangle({ x, y, width: w, height: h, color: fill, borderColor: border || C.borda, borderWidth: 0.5 });
  const drawText  = (pg, t, x, y, s, f, color) => pg.drawText(String(t ?? ''), { x, y, size: s, font: f, color });
  const drawLine  = (pg, x1, y1, x2, y2, color = C.borda, t = 0.5) => pg.drawLine({ start: { x: x1, y: y1 }, end: { x: x2, y: y2 }, thickness: t, color });

  const tH = 14;
  const drawRow = (pg, cells, y) => {
    cells.forEach((c) => {
      drawBRect(pg, c.x, y - tH + 2, c.w, tH, c.fill, c.bc || C.borda);
      if (c.text != null && c.text !== '') {
        const sz = c.sz || 8; const fn = c.fn || fontReg;
        let tx = c.x + 3;
        if (c.al === 'r') tx = c.x + c.w - fn.widthOfTextAtSize(String(c.text), sz) - 3;
        if (c.al === 'c') tx = c.x + (c.w - fn.widthOfTextAtSize(String(c.text), sz)) / 2;
        drawText(pg, c.text, tx, y - tH + 5, sz, fn, c.cl || C.preto);
      }
    });
    return y - tH;
  };

  // ── Logo ──────────────────────────────────────────────────────────────────
  let logoImage = null;
  let empresa = null;
  try {
    empresa = await getEmpresaAtual();
    if (empresa?.logoBranca) {
      const base64 = empresa.logoBranca.split(',')[1];
      const bin = atob(base64);
      const bytes = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i += 1) bytes[i] = bin.charCodeAt(i);
      logoImage = await pdfDoc.embedPng(bytes);
    }
  } catch (e) { /* sem logo */ }

  const usuarioLogado = JSON.parse(localStorage.getItem('userData') || '{}');
  const solicitante   = usuarioLogado?.nome || '—';

  const TITULO = 'Relatório de Serviços Reprovados';

  const drawHeader = (pg, titulo) => {
    drawRect(pg, 0, H - 44, W, 44, C.cinzaChumbo);
    drawRect(pg, 0, H - 44, 6, 44, C.laranja);
    if (logoImage) {
      const lDims = logoImage.scaleToFit(70, 28);
      pg.drawImage(logoImage, { x: ML, y: H - 39, width: lDims.width, height: lDims.height });
    } else {
      drawText(pg, empresa?.nome || 'Marcki Engenharia', ML, H - 26, 11, fontBold, C.branco);
    }
    drawText(pg, titulo, W - MR - fontBold.widthOfTextAtSize(titulo, 10), H - 24, 10, fontBold, C.branco);
    const periodo = [
      filtro?.datainicial ? new Date(filtro.datainicial).toLocaleDateString('pt-BR') : '',
      filtro?.datafinal   ? new Date(filtro.datafinal).toLocaleDateString('pt-BR')   : '',
    ].filter(Boolean).join(' até ');
    if (periodo) drawText(pg, `Período: ${periodo}`, W - MR - fontReg.widthOfTextAtSize(`Período: ${periodo}`, 8), H - 36, 8, fontReg, rgb(0.8, 0.8, 0.8));
    return H - 58;
  };

  const drawFooter = (pg) => {
    drawRect(pg, 0, 0, W, 26, C.cinzaChumbo);
    drawRect(pg, 0, 0, 6, 26, C.laranja);
    drawText(pg, `Solicitante: ${solicitante}`, ML + 8, 9, 7, fontReg, rgb(0.8, 0.8, 0.8));
    drawText(pg, `Gerado em ${new Date().toLocaleDateString('pt-BR')}`, W - MR - 70, 9, 7, fontReg, rgb(0.8, 0.8, 0.8));
  };

  const linhas = data.linhas || [];
  const resumo = data.resumo || {};

  const nomesServicos = (p) => (p.servicos || []).map((s) => s.nome).join(', ') || '—';

  const dadosMotivos = Object.entries(
    linhas.reduce((acc, p) => {
      const m = p.motivoNome || 'Outros';
      acc[m] = (acc[m] || 0) + 1;
      return acc;
    }, {})
  ).map(([nome, qtd]) => ({ nome, qtd })).sort((a, b) => b.qtd - a.qtd);

  const total = dadosMotivos.reduce((s, d) => s + d.qtd, 0);

  const pizzaDataUrl  = await gerarGraficoPizzaCanvas(dadosMotivos, total, CORES_HEX);
  const pizzaPngBytes = await fetch(pizzaDataUrl).then((r) => r.arrayBuffer());
  const pizzaImg      = await pdfDoc.embedPng(pizzaPngBytes);

  // ============================================================
  // PG 1 — KPIs + GRÁFICOS
  // ============================================================
  const p1 = pdfDoc.addPage([W, H]);
  let y1 = drawHeader(p1, TITULO);
  y1 -= 10;

  const periodo = [
    filtro?.datainicial ? new Date(filtro.datainicial).toLocaleDateString('pt-BR') : '',
    filtro?.datafinal   ? new Date(filtro.datafinal).toLocaleDateString('pt-BR')   : '',
  ].filter(Boolean).join(' até ');
  if (periodo) {
    drawText(p1, `De ${periodo}`, ML, y1, 8, fontReg, C.cinzaMedio);
    y1 -= 14;
  }
  if (filtro?.servico) {
    drawText(p1, `Serviço: ${filtro.servico}`, ML, y1, 8, fontReg, C.laranja);
    y1 -= 14;
  }

  // ── KPIs (sem Potência — nao se aplica a servico) ──────────────────────────
  const kpiW = (CW - 15) / 4;
  const kpiH = 36;
  const kpis = [
    { label: 'Total de Projetos', valor: fmtNum(resumo.totalRejeitados) },
    { label: 'Total Perdido',     valor: isSupervisor ? brl(resumo.somaValor) : 'Restrito' },
    { label: '% Reprovados',      valor: `${Number(resumo.percentualReprovados || 0).toFixed(2)}%` },
    { label: 'Ticket Médio',      valor: isSupervisor ? brl(resumo.ticketMedioValor) : 'Restrito' },
  ];

  kpis.forEach((kpi, i) => {
    const x = ML + i * (kpiW + 5);
    drawBRect(p1, x, y1 - kpiH, kpiW, kpiH, C.laranjaClaro, C.laranja);
    drawRect(p1, x, y1 - kpiH, 3, kpiH, C.laranja);
    drawText(p1, kpi.label, x + 6, y1 - 13, 7, fontReg, C.cinzaMedio);
    drawText(p1, kpi.valor, x + 6, y1 - 28, 10, fontBold, C.cinzaChumbo);
  });
  y1 -= kpiH + 10;

  drawText(p1, `Motivo Principal: ${String(resumo.maiorMotivo || '—').substring(0, 60)}`, ML, y1, 8, fontReg, C.cinzaMedio);
  y1 -= 16;

  // ── Gráfico de Barras ─────────────────────────────────────────────────────
  drawText(p1, 'Reprovas por Motivo', ML, y1, 10, fontBold, C.preto);
  y1 -= 14;

  const maxQtd   = Math.max(...dadosMotivos.map((d) => d.qtd), 1);
  const barAreaW = CW * 0.55;
  const labelW   = CW * 0.36;
  const barX     = ML + labelW + 8;

  for (let i = 0; i <= 4; i += 1) {
    const gx = barX + (barAreaW / 4) * i;
    drawLine(p1, gx, y1 - 2, gx, y1 - dadosMotivos.length * 20 - 8, C.cinzaClaro);
    drawText(p1, String(Math.round((maxQtd / 4) * i)), gx - 4, y1 - dadosMotivos.length * 20 - 16, 6, fontReg, C.cinzaMedio);
  }

  dadosMotivos.forEach((d, i) => {
    const barY  = y1 - 8 - i * 20;
    const barW  = (d.qtd / maxQtd) * barAreaW;
    const cor   = CORES_RGB[i % CORES_RGB.length];
    const label = d.nome.length > 28 ? `${d.nome.substring(0, 28)}...` : d.nome;
    drawText(p1, label, ML, barY + 3, 7, fontReg, C.preto);
    drawRect(p1, barX, barY, barW, 11, cor);
    drawText(p1, String(d.qtd), barX + barW + 4, barY + 3, 7, fontBold, C.preto);
  });

  y1 -= dadosMotivos.length * 20 + 24;
  drawText(p1, `Total de propostas rejeitadas: ${total}`, ML, y1, 8, fontReg, C.cinzaMedio);
  y1 -= 18;

  // ── Gráfico de Pizza ──────────────────────────────────────────────────────
  drawText(p1, 'Reprovas', ML + CW / 2 - 20, y1, 10, fontBold, C.preto);
  y1 -= 10;

  const pizzaSize = 140;
  const pizzaX    = ML + CW / 2 - pizzaSize / 2;
  p1.drawImage(pizzaImg, { x: pizzaX, y: y1 - pizzaSize, width: pizzaSize, height: pizzaSize });

  let legY = y1 - pizzaSize / 2 + (dadosMotivos.length * 7);
  dadosMotivos.forEach((d, i) => {
    const pct   = total > 0 ? ((d.qtd / total) * 100).toFixed(1) : '0';
    const cor   = CORES_RGB[i % CORES_RGB.length];
    const label = d.nome.length > 22 ? `${d.nome.substring(0, 22)}...` : d.nome;
    drawRect(p1, ML, legY - 7, 9, 9, cor);
    drawText(p1, `${label}: ${pct}%`, ML + 12, legY - 5, 7, fontReg, C.preto);
    legY -= 14;
  });

  y1 -= pizzaSize + 10;
  drawFooter(p1);

  // ============================================================
  // PG 2 — TABELA
  // ============================================================
  const p2 = pdfDoc.addPage([W, H]);
  let y2 = drawHeader(p2, TITULO);
  y2 -= 16;

  drawText(p2, 'Serviços Reprovados', ML, y2, 10, fontBold, C.preto);
  y2 -= 14;

  const c1 = CW * 0.20; const c2 = CW * 0.10; const c3 = CW * 0.22;
  const c4 = CW * 0.14; const c5 = CW * 0.16; const c6 = CW - c1 - c2 - c3 - c4 - c5;

  y2 = drawRow(p2, [
    { x: ML,                w: c1, fill: C.laranja, text: 'Nome do Cliente',    fn: fontBold, cl: C.branco },
    { x: ML+c1,             w: c2, fill: C.laranja, text: 'Data',               fn: fontBold, cl: C.branco },
    { x: ML+c1+c2,          w: c3, fill: C.laranja, text: 'Tipo(s) de Serviço', fn: fontBold, cl: C.branco },
    { x: ML+c1+c2+c3,       w: c4, fill: C.laranja, text: 'Valor do Projeto',   fn: fontBold, cl: C.branco, al: 'r' },
    { x: ML+c1+c2+c3+c4,    w: c5, fill: C.laranja, text: 'Consultor',          fn: fontBold, cl: C.branco },
    { x: ML+c1+c2+c3+c4+c5, w: c6, fill: C.laranja, text: 'Motivo',             fn: fontBold, cl: C.branco },
  ], y2);

  linhas.forEach((p, i) => {
    if (y2 < 50) return;
    const fill = i % 2 === 0 ? C.cinzaClaro : C.branco;
    y2 = drawRow(p2, [
      { x: ML,                w: c1, fill, text: (p.cliente?.nome || '').substring(0, 22) },
      { x: ML+c1,             w: c2, fill, text: p.data },
      { x: ML+c1+c2,          w: c3, fill, text: nomesServicos(p).substring(0, 30) },
      { x: ML+c1+c2+c3,       w: c4, fill, text: isSupervisor ? brl(p.valor) : 'Rest.', al: 'r' },
      { x: ML+c1+c2+c3+c4,    w: c5, fill, text: (p.user?.nome || '').substring(0, 18) },
      { x: ML+c1+c2+c3+c4+c5, w: c6, fill, text: (p.motivoNome || '').substring(0, 18) },
    ], y2);
  });

  y2 -= 6;
  drawBRect(p2, ML, y2 - tH + 2, CW, tH, C.laranjaClaro, C.laranja);
  drawText(p2, `Total: ${linhas.length} propostas`, ML + 4, y2 - tH + 5, 8, fontBold, C.laranjaEsc);
  if (isSupervisor) {
    const totalVal = brl(linhas.reduce((s, p) => s + (p.valor || 0), 0));
    drawText(p2, `Total Perdido: ${totalVal}`, ML + c1 + c2 + c3 - 4, y2 - tH + 5, 8, fontBold, C.laranjaEsc);
  }

  y2 -= 20;
  drawText(p2, `Motivo Principal: ${resumo.maiorMotivo || '—'} — Gerado em ${new Date().toLocaleDateString('pt-BR')}`, ML, y2, 8, fontReg, C.cinzaMedio);

  if (!isSupervisor) {
    y2 -= 14;
    drawText(p2, 'Dados financeiros protegidos por LGPD — acesso restrito ao supervisor.', ML, y2, 7, fontReg, C.cinzaMedio);
  }

  drawFooter(p2);

  const pdfBytes = await pdfDoc.save();
  const blob     = new Blob([pdfBytes], { type: 'application/pdf' });
  const url      = URL.createObjectURL(blob);
  const link     = document.createElement('a');
  link.href      = url;
  link.download  = 'relatorio-servicos-reprovados.pdf';
  link.click();
  URL.revokeObjectURL(url);
};

export default generatePdfRejeitadosServico;